import { FieldSchema } from "./FieldSchema";
import { ConditionSchema } from "./ConditionSchema";
import { FormulaField } from "./FormulaField";

export class FormSchema {
  fields?: FormulaField[];
  conditions?: ConditionSchema[];
  type!: string;
  allOf!: FieldSchema[];
}
